export default __webpack_public_path__ + "static/media/applepay.ed5c0fd6.png";